import { createApiFactory, createPlugin, createRoutableExtension, discoveryApiRef, identityApiRef } from '@backstage/core-plugin-api';
import { gluesApiRef } from './api';
import { AgentClient } from './api/agentClient';
import { GluesManagement } from './api/gluesManagementClient';
import { agentApiRef } from './api/types';

import { gluesManagementPluginRouteRef } from './routes';

export const gluesManagementPlugin = createPlugin({
  id: 'glues-management',
  apis: [
    createApiFactory({
      api: gluesApiRef,
      deps: {
        discoveryApi: discoveryApiRef
      },
      factory: ({ discoveryApi }) => new GluesManagement({ discoveryApi })
    }),
    createApiFactory({
      api: agentApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        identityApi: identityApiRef
      },
      factory: ({ discoveryApi, identityApi }) => new AgentClient({ discoveryApi, identityApi })
    })
  ],
  routes: {
    root: gluesManagementPluginRouteRef,
  },
});

export const EntityGluesManagementPage = gluesManagementPlugin.provide(
  createRoutableExtension({
    name: 'EntityGluesManagementPage',
    component: () => 
      import('./components/GluesManagement/GluesManagement').then(m => m.GluesManagementPage),
    mountPoint: gluesManagementPluginRouteRef
  })
);

export const EntityGluesServiceConfigContent = gluesManagementPlugin.provide(
  createRoutableExtension({
    name: 'EntityGluesServiceConfigContent',
    component: () =>
      import('./components/ServiceConfig/ServiceConfig').then(m => m.ServiceConfig),
    mountPoint: gluesManagementPluginRouteRef,
  }),
);

export const EntityGluesDevToggleContent = gluesManagementPlugin.provide(
  createRoutableExtension({
    name:'EntityGluesDevToggleContent',
    component: () =>
      import('./components/DevToggle/DevToggle').then(m => m.DevToggle),
    mountPoint: gluesManagementPluginRouteRef
  }),
);

export const EntityGluesFeatureToggleContent = gluesManagementPlugin.provide(
  createRoutableExtension({
    name:'EntityGluesFeatureToggleContent',
    component: () =>
      import('./components/FeatureToggle/FeatureToggle').then(m => m.FeatureToggle),
    mountPoint: gluesManagementPluginRouteRef
  }),
);

export const EntityGluesThirdPartyConfigContent = gluesManagementPlugin.provide(
  createRoutableExtension({
    name:'EntityGluesThirdPartyConfigContent',
    component: () =>
      import('./components/ThirdPartyConfig/ThirdPartyConfig').then(m => m.ThirdPartyConfig),
    mountPoint: gluesManagementPluginRouteRef
  }),
);